import { render, staticRenderFns } from "./SubmitFormControls.vue?vue&type=template&id=19856fe3"
import script from "./SubmitFormControls.vue?vue&type=script&lang=js"
export * from "./SubmitFormControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports